"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenu = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _SubMenuLinks = require("./SubMenuLinks");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node
} : {};

var SubMenu = function SubMenu(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      domain = _ref3$.domain,
      isOpen = _ref3$.isOpen,
      isOpenSubMenu = _ref3$.isOpenSubMenu,
      isCustomType = _ref3$.isCustomType,
      fixed = _ref3$.fixed,
      isMobile = _ref3$.isMobile,
      currentConfig = _ref3$.currentConfig,
      ProductLogo = _ref3$.ProductLogo,
      handleDispatchSubMenuEvents = _ref3[1].handleDispatchSubMenuEvents;

  var name = currentConfig.name,
      colors = currentConfig.colors,
      link = currentConfig.link,
      links = currentConfig.links;

  var subMenuLogoProps = function subMenuLogoProps(logoLink) {
    var commonProps = {
      onClick: function onClick() {
        return handleDispatchSubMenuEvents({
          action: "inbound links | logo ".concat(name.toLowerCase()),
          label: logoLink ? "".concat(domain).concat(logoLink) : ''
        });
      }
    };

    var propsWithLink = _objectSpread({
      as: 'a',
      href: "".concat(domain).concat(logoLink)
    }, commonProps);

    var propsWithoutLink = _objectSpread({
      as: 'span'
    }, commonProps);

    return link ? propsWithLink : propsWithoutLink;
  };

  if (isMobile && !links.length) {
    return null;
  }

  return (0, _core.jsx)(_UiComponents.Container.Backdrop, {
    fixed: fixed,
    isOpen: isOpen,
    isOpenSubMenu: isOpenSubMenu,
    isCustomType: isCustomType
  }, (0, _core.jsx)(_UiComponents.Container.SubMenu, {
    bgColor: colors.background
  }, (0, _core.jsx)(_UiComponents.Container.Wrapper, {
    maxWidth: "lg"
  }, !isMobile && (0, _core.jsx)(_UiComponents.Container.SubMenuLogo, (0, _extends2.default)({}, subMenuLogoProps(link), {
    color: colors.active
  }), (0, _core.jsx)(ProductLogo, null)), (0, _core.jsx)(_SubMenuLinks.SubMenuLinks, null, children), !isMobile && children && (0, _core.jsx)(_UiComponents.Layout.Flex, {
    padding: 0,
    alignItems: "center"
  }, (0, _core.jsx)(_UiComponents.Container.SubMenuChildren, null, (0, _core.jsx)(_UiComponents.Layout.Flex, {
    justifyContent: "flex-end",
    padding: 0
  }, children))))));
};

exports.SubMenu = SubMenu;
process.env.NODE_ENV !== "production" ? SubMenu.propTypes = propTypes : void 0;
SubMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SubMenu",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};